import { IEntry } from './IEntry';
import { NEWS_ALERT_TYPE_ID } from '../constants';

export enum NewsAlertType {
	EmergencyInformation = 'Emergency Information',
	Warning = 'Warning',
}

// Fields of the Contentful `news-alert` content type.
export interface INewsAlertFields {
	title: string;
	body: string;
	link?: string;
	linkLabel?: string;
	type: NewsAlertType;
}

export interface INewsAlertEntry
	extends IEntry<INewsAlertFields, typeof NEWS_ALERT_TYPE_ID> {}

// Flattened alert as served by `/api/alerts` and consumed by the banner.
export interface INewsAlert extends INewsAlertFields {
	id: string;
}
